// Import the configureStore function from Redux Toolkit
import { configureStore } from '@reduxjs/toolkit';

// Import the auth reducer from the authSlice file
import authReducer from "./features/authSlice"
const { NODE_ENV } = process.env
// Create and export the Redux store
export const store = configureStore({
    reducer: {
        // Add the auth reducer to the store
        auth: authReducer,
    },
    devTools: NODE_ENV === "development"
});